import AppRouting from '../routing/AppRouting';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../data/store';
import { LicenseInfo } from '@mui/x-license-pro';
import { GoogleMapsContextProvider } from '../contexts/GoogleMapsProvider';
import { getTheme } from '../theme';
import { usePortalName } from '../hooks/usePortalName';

const { __environment__ } = window as Window & {
  __environment__: {
    REACT_APP_DATA_GRID_PRO_KEY: string;
  };
};
const dataGripProKey = __environment__.REACT_APP_DATA_GRID_PRO_KEY;

LicenseInfo.setLicenseKey(dataGripProKey);

const App = () => {
  const portalName = usePortalName();
  const theme = getTheme(portalName);
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Provider store={store}>
            <GoogleMapsContextProvider>
              <AppRouting />
            </GoogleMapsContextProvider>
          </Provider>
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
